import React, { useState, useEffect } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";

export default function CreateAgent({ onClose, agent, onAdd, onUpdate }) {
  const isEdit = !!agent;

  const [form, setForm] = useState({
    name: "",
    number: "",
    commissionPerKg: "",
  });

  useEffect(() => {
    if (isEdit && agent) {
      setForm({
        name: agent.name || "",
        number: agent.phone || "",
        commissionPerKg: agent.commissionPerKg?.toFixed(2) || "",
      });
    }
  }, [agent, isEdit]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isEdit) {
      await onUpdate(form);
    } else {
      await onAdd(form);
    }
  };

  return (
    <>
      <div className="overlay" onClick={onClose}></div>

      <div className="addproduct-container addagent-container">
        <div className="header d-flex justify-content-between align-items-center mb-4">
          <h4 className="fw-bold mb-0">{isEdit ? "Edit Agent" : "Add Agent"}</h4>
          <button onClick={onClose} className="close-btn">×</button>
        </div>

        <Form onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Col>
              <Form.Group>
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Number</Form.Label>
                <Form.Control
                  type="text"
                  name="number"
                  value={form.number}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-4">
            <Form.Label>Commission per Kg</Form.Label>
            <Form.Control
              type="number"
              name="commissionPerKg"
              value={form.commissionPerKg}
              onChange={handleChange}
              step="0.01"
              required
            />
          </Form.Group>

          <div className="text-end">
            <Button type="submit" className="add-btn">
              {isEdit ? "UPDATE AGENT" : "ADD AGENT"}
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}
